import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {ModalAddAttachmentComponent} from "../../modals/modal-add-attachment/modal-add-attachment.component";


@Component({
    selector: 'app-attachment-manager',
    templateUrl: './attachment-manager.component.html',
    styleUrls: ['./attachment-manager.component.scss'],
    standalone: false
})
export class AttachmentManagerComponent {
  @Input() attachments: Attachment[] = [];
  @Input() allowedAttachmentTypes: string[] = ['FILE', 'PUBMED'];
  @Input() uploadUrl = 'upload/tmp-proposal-file';
  @Output() attachmentsChange = new EventEmitter<Attachment[]>();

  constructor(private dialog: MatDialog) {}

  /**
   * Apre il dialog per aggiungere un nuovo allegato in base al tipo
   */
  onAddAttachment(type: string): void {
    const dialogRef = this.dialog.open(ModalAddAttachmentComponent, {
      panelClass: 'large-dialog',
      data: {
        title: 'modals.modal-add-attachment.add-evidences',
        attachmentType: type,
        uploadUrl: this.uploadUrl
      }
    });

    dialogRef.afterClosed().subscribe((attachmentData) => {
      if (attachmentData) {
        // Gestione in base al tipo di allegato
        if (attachmentData.attachmentType === 'PUBMED') {
          const newAttachment: Attachment = {
            type: 'PUBMED',
            PMID: attachmentData.attachmentObject.PMID,
            title: attachmentData.attachmentObject.ArticleTitle,
            link: attachmentData.attachmentObject.link
          };
          this.attachments.push(newAttachment);
        } else if (attachmentData.attachmentType === 'FILE') {
          // Se l'upload restituisce un array di file (altrimenti gestisci come singolo file)
          if (Array.isArray(attachmentData.attachmentObject)) {
            attachmentData.attachmentObject.forEach(file => {
              const newAttachment: Attachment = {
                id: file.id,
                type: 'FILE',
                ext: file.ext,
                size: file.size,
                title: file.title,
                link: file.link
              };
              this.attachments.push(newAttachment);
            });
          } else {
            const file = attachmentData.attachmentObject;
            const newAttachment: Attachment = {
              id: file.id,
              type: 'FILE',
              ext: file.ext,
              size: file.size,
              title: file.title,
              link: file.link
            };
            this.attachments.push(newAttachment);
          }
        }
        // Notifica la variazione al padre
        this.attachmentsChange.emit(this.attachments);
      }
    });
  }

  /**
   * Rimuove un allegato dall'array in base all'indice
   */
  onRemoveAttachment(index: number): void {
    this.attachments.splice(index, 1);
    this.attachmentsChange.emit(this.attachments);
  }
}

export interface Attachment {
  id?: string;            // per allegati FILE
  type: string;           // ad es.: 'FILE', 'PUBMED', etc.
  title: string;
  link: string;
  size?: number;          // dimensione per file
  ext?: string;           // estensione per file
  PMID?: string;          // identificativo per Pubmed
}
